import { render, staticRenderFns } from "./DeletedInfoMessage.vue?vue&type=template&id=62b34d94"
import script from "./DeletedInfoMessage.vue?vue&type=script&lang=js"
export * from "./DeletedInfoMessage.vue?vue&type=script&lang=js"
import style0 from "./DeletedInfoMessage.vue?vue&type=style&index=0&id=62b34d94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports